import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Input.module.css';

const Input = forwardRef(function Input(
  { label, error, className, id, ...props },
  ref
) {
  return (
    <div className={clsx(styles.wrap, className)}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <input
        id={id}
        ref={ref}
        className={clsx(styles.input, error && styles.hasError)}
        {...props}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
});

export default Input;
